// 百科：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 个人百科
export const personal = Object.freeze({
  "myWiki.center": "百科中心",
  "myWiki.all": "全部",
  "myWiki.viewLibrary": "查看百科库",
  "myWiki.publish": "发布百科",
  "myWiki.mine.title": "我的发布",
  "myWiki.mine.description": "查看当前账号发布或维护过的百科记录。",
  "myWiki.mine.search": "搜索我的发布",
  "myWiki.mine.entry": "词条名称",
  "myWiki.mine.definition": "词条释义",
  "myWiki.mine.source": "来源",
  "myWiki.mine.status": "状态",
  "myWiki.mine.reviewFeedback": "审核意见",
  "myWiki.mine.publishedAt": "发布时间",
  "myWiki.mine.actions": "操作",
  "myWiki.mine.view": "查看",
  "myWiki.mine.noDefinition": "暂无词条释义",
  "myWiki.mine.empty": "暂无当前账号发布记录",
  "myWiki.mine.contributed": "参与修改",
  "myWiki.mine.userSource": "用户发布",
  "myWiki.mine.internalSource": "内部发布",
  "myWiki.status.reviewing": "待审核",
  "myWiki.status.pending_review": "智能审核中",
  "myWiki.status.ai_correction_pending": "待确认",
  "myWiki.status.revision_required": "需修改",
  "myWiki.status.manual_review": "人工复核",
  "myWiki.status.published": "已发布",
  "myWiki.status.offline": "已下架",
  "myWiki.status.scheduled": "计划发布",
  "myWiki.status.rejected": "审核不通过",
  "myWiki.status.draft": "草稿",
  "myWiki.collection.title": "我的收藏",
  "myWiki.collection.summary": "收藏统计",
  "myWiki.collection.saved": "收藏",
  "myWiki.collection.current": "当前",
  "myWiki.collection.brands": "品牌",
  "myWiki.collection.description":
    "集中管理已收藏的芯片百科型号，快速查看详情和资料完整度。",
  "myWiki.collection.searchPlaceholder": "搜索型号、品牌、分类",
  "myWiki.collection.noSummary": "暂无简介",
  "myWiki.collection.completeness": "资料完整度",
  "myWiki.collection.viewDetail": "查看详情",
  "myWiki.collection.removeFavorite": "取消收藏",
  "myWiki.collection.empty": "暂无收藏内容",
  "myWiki.collection.removed": "已取消收藏",
  "myWiki.collection.removeFailed": "取消收藏失败，请稍后重试",
  "myWiki.questions.title": "我的问答",
  "myWiki.questions.description": "查看你在芯片百科中提出的问题、回答和评论。",
  "myWiki.questions.enterCommunity": "进入百科问答",
  "myWiki.questions.questions": "我的提问",
  "myWiki.questions.answers": "我的回答",
  "myWiki.questions.comments": "我的评论",
  "myWiki.questions.loginPrompt": "登录后查看你的问答记录。",
  "myWiki.questions.loginNow": "立即登录",
  "myWiki.questions.loading": "正在加载…",
  "myWiki.questions.retry": "重试",
  "myWiki.questions.loginAgain": "重新登录",
  "myWiki.questions.attachmentAnswer": "附件回答",
  "myWiki.questions.noDescription": "未补充说明",
  "myWiki.questions.answerCount": "{count} 个回答",
  "myWiki.questions.answered": "回答了该问题",
  "myWiki.questions.commented": "参与了该问题的讨论",
  "myWiki.questions.delete": "删除",
  "myWiki.questions.deleted": "已删除",
  "myWiki.questions.viewDiscussion": "查看讨论",
  "myWiki.questions.empty.questions": "暂未发布问题",
  "myWiki.questions.empty.answers": "暂未发布回答",
  "myWiki.questions.empty.comments": "暂未发布评论",
  "myWiki.questions.loginExpired": "登录已失效，请重新登录。",
  "myWiki.questions.loadFailed": "问答记录加载失败，请稍后重试。",
  "myWiki.questions.deleteSuccess": "已删除",
  "myWiki.questions.deleteOwnOnly": "只能删除自己的内容。",
  "myWiki.questions.deleteUnavailable":
    "删除接口尚未启用或该内容已不可用，未删除。",
  "myWiki.questions.deleteFailed": "删除失败，请稍后重试。",
});

// 百科受控显示
export const display = Object.freeze({
  "wikiDisplay.category.memory": "存储器",
  "wikiDisplay.category.flash": "闪存",
  "wikiDisplay.category.nand": "NAND 闪存",
  "wikiDisplay.category.nor": "NOR 闪存",
  "wikiDisplay.category.ssd": "固态硬盘",
  "wikiDisplay.category.chip": "芯片",
  "wikiDisplay.category.wiki": "百科",
  "wikiDisplay.category.mcu": "微控制器",
  "wikiDisplay.category.power": "电源管理芯片",
  "wikiDisplay.category.interface": "接口芯片",
  "wikiDisplay.category.sensor": "传感器",
  "wikiDisplay.parameter.capacity": "容量",
  "wikiDisplay.parameter.density": "存储密度",
  "wikiDisplay.parameter.accessTime": "访问时间",
  "wikiDisplay.parameter.package": "封装",
  "wikiDisplay.parameter.voltage": "电压",
  "wikiDisplay.parameter.operatingVoltage": "工作电压",
  "wikiDisplay.parameter.supplyVoltage": "供电电压",
  "wikiDisplay.parameter.speed": "速率",
  "wikiDisplay.parameter.frequency": "频率",
  "wikiDisplay.parameter.temperature": "工作温度",
  "wikiDisplay.parameter.interface": "接口",
  "wikiDisplay.parameter.width": "位宽",
  "wikiDisplay.parameter.organization": "组织",
  "wikiDisplay.parameter.pins": "引脚数",
  "wikiDisplay.parameter.process": "制程",
  "wikiDisplay.parameter.power": "功耗",
  "wikiDisplay.parameter.brand": "品牌厂商",
  "wikiDisplay.parameter.manufacturer": "制造商",
  "wikiDisplay.parameter.category": "所属分类",
  "wikiDisplay.parameter.model": "型号",
  "wikiDisplay.parameter.period": "供货状态",
  "wikiDisplay.parameter.description": "内容描述",
  "wikiDisplay.parameter.base": "基础资料",
  "wikiDisplay.parameter.spec": "核心规格",
  "wikiDisplay.parameter.packaging": "封装信息",
  "wikiDisplay.parameter.parameter": "参数",
  "wikiDisplay.parameter.datasheet": "规格书",
  "wikiDisplay.parameter.body": "百科正文",
  "wikiDisplay.parameter.dataRate": "数据速率",
  "wikiDisplay.parameter.productName": "产品名称",
  "wikiDisplay.parameter.partNumber": "料号型号",
  "wikiDisplay.parameter.series": "产品系列",
  "wikiDisplay.parameter.price": "参考单价",
  "wikiDisplay.parameter.quantity": "库存数量",
  "wikiDisplay.parameter.location": "货所在地",
  "wikiDisplay.parameter.batch": "批次",
  "wikiDisplay.parameter.condition": "货物情况",
  "wikiDisplay.parameter.application": "应用领域",
  "wikiDisplay.parameter.moq": "起订量",
  "wikiDisplay.parameter.leadTime": "交货周期",
  "wikiDisplay.parameter.validity": "有效期",
  "wikiDisplay.parameter.alternative": "替代型号",
  "wikiDisplay.parameter.cas": "CAS 延迟",
  "wikiDisplay.status.draft": "草稿",
  "wikiDisplay.status.reviewing": "待审核",
  "wikiDisplay.status.processing": "审核中",
  "wikiDisplay.status.manual": "人工复核",
  "wikiDisplay.status.confirm": "待确认",
  "wikiDisplay.status.revision": "需修改",
  "wikiDisplay.status.rejected": "审核不通过",
  "wikiDisplay.status.denied": "已拒绝",
  "wikiDisplay.status.published": "已发布",
  "wikiDisplay.status.offline": "已下架",
  "wikiDisplay.status.scheduled": "计划发布",
  "wikiDisplay.review.pendingPreview": "待审核版本预览",
  "wikiDisplay.review.view": "百科查看详情",
  "wikiDisplay.review.pendingVersionHint":
    "当前展示的是用户本次提交的修改内容，不是百科库中的已发布版本。",
  "wikiDisplay.review.readOnlyHint":
    "当前为查看入口，只查看该百科条目的公开展示内容和发布状态。",
  "wikiDisplay.review.internal": "内部百科管理详情",
  "wikiDisplay.review.processingTitle": "该百科内容正在审核",
  "wikiDisplay.review.processingHint":
    "这是你的提交预览，内容暂未进入公开百科库。审核通过后，其他用户才能在百科详情中看到正式版本。",
  "wikiDisplay.review.aiTitle": "AI 已生成修正建议",
  "wikiDisplay.review.aiHint":
    "请核对下方修改前后对比；接受后会重新审核，不确认则转人工复核。",
  "wikiDisplay.review.manualTitle": "该百科内容正在人工复核",
  "wikiDisplay.review.manualHint":
    "人工审核通过后发布；不通过会退回到“需修改”。",
  "wikiDisplay.review.revisionTitle": "该百科内容已退回修改",
  "wikiDisplay.review.revisionHint": "请根据审核意见修正后重新提交。",
  "wikiDisplay.review.rejectedTitle": "该百科内容未通过审核",
  "wikiDisplay.review.rejectedHint":
    "该版本已终止发布，具体原因请查看下方审核意见。",
  "wikiDisplay.review.offlineTitle": "该百科内容已由管理员下架",
  "wikiDisplay.review.offlineHint":
    "该内容已停止公开展示，具体原因请查看下方管理意见。",
  "wikiDisplay.review.draftTitle": "该百科有未提交的修改草稿",
  "wikiDisplay.review.draftHint":
    "当前草稿仅你本人可见；已发布版本仍正常对外展示。",
  "wikiDisplay.review.withdrawnTitle": "该百科投稿已撤回",
  "wikiDisplay.review.withdrawnHint":
    "当前内容仅你本人可见，不再进入审核队列。",
  "wikiDisplay.review.publishedTitle": "该百科内容已发布",
  "wikiDisplay.review.publishedHint":
    "这是已通过审核的公开百科详情，用户可以从百科库和相关产品入口访问。",
  "wikiDisplay.review.waitManual": "等待人工审核结论",
  "wikiDisplay.review.waitInternal": "等待内部确认后发布",
  "wikiDisplay.review.allowed": "已允许进入公开百科库",
  "wikiDisplay.review.hidden": "已停止公开展示",
  "wikiDisplay.review.stopped": "该版本已终止发布",
  "wikiDisplay.review.internalDraft": "内部暂存，未进入公开库",
  "wikiDisplay.review.checkSubmitted":
    "当前展示用户本次提交的待审核版本。请核对内容后选择审核通过或退回修改。",
  "wikiDisplay.review.checkQueue":
    "该条目来自百科审核队列，可在此核对图片、参数、词条字段和内容描述后再确认发布。",
  "wikiDisplay.review.checkPublished":
    "该条目已通过审核并进入百科库，可继续核对资料完整度或补齐规格、图片、商品关联信息。",
  "wikiDisplay.review.checkOffline":
    "该词条已下架，不会进入用户修改队列；如需恢复，请先转为人工复核并重新审核。",
  "wikiDisplay.review.checkRejected":
    "该版本未通过人工审核，不能继续进入发布流程。",
  "wikiDisplay.review.checkDraft":
    "该条目处于内部草稿状态，可继续补齐资料后转入待审核或直接发布。",
  "wikiDisplay.review.approve": "审核通过并发布",
  "wikiDisplay.review.return": "退回修改",
  "wikiDisplay.review.returnMore": "退回补充",
  "wikiDisplay.review.offlinePending": "下架转待审",
  "wikiDisplay.review.pendingAgain": "重新待审",
  "wikiDisplay.review.saveDraft": "保存草稿",
  "wikiDisplay.review.plan": "制定审核计划",
  "wikiDisplay.review.identify": "识别产品型号",
  "wikiDisplay.review.retrieve": "检索规格书证据",
  "wikiDisplay.review.extract": "提取关键参数",
  "wikiDisplay.review.advertising": "检查广告与导流",
  "wikiDisplay.review.objectivity": "检查内容客观性",
  "wikiDisplay.review.verify": "逐项事实核验",
  "wikiDisplay.review.check": "审核检查",
  "wikiDisplay.review.supported": "原文支持",
  "wikiDisplay.review.contradicted": "存在矛盾",
  "wikiDisplay.review.insufficient": "证据不足",
  "wikiDisplay.review.unverified": "待核验",
  "wikiDisplay.parameterText": "{label}：{value}",
  "wikiDisplay.favorite.added": "已添加到收藏",
  "wikiDisplay.favorite.removed": "已取消收藏",
  "wikiDisplay.error.AUTH_REQUIRED": "请先登录后再操作",
  "wikiDisplay.error.FORBIDDEN": "当前账号没有此操作权限",
  "wikiDisplay.error.NOT_FOUND": "未找到对应的百科内容",
  "wikiDisplay.error.INVALID_ARGUMENT":
    "提交内容不完整或参数无效，请检查后重试",
  "wikiDisplay.error.RATE_LIMITED": "请求过于频繁，请稍后重试",
  "wikiDisplay.error.TIMEOUT": "百科服务响应超时，请稍后重试",
  "wikiDisplay.error.UNAVAILABLE": "百科服务暂不可用，请稍后重试",
  "wikiDisplay.error.REQUEST_FAILED": "操作失败，请稍后重试",
  "wikiDisplay.error.PUBLISH_FAILED": "发布百科内容失败，请稍后重试",
  "wikiDisplay.error.ROW_REQUIRED": "第 {index} 条缺少必填内容",
});

// 百科页面
export const pages = Object.freeze({
  "wiki.backToEntry": "返回词条",
  "wiki.community": "芯片百科社区",
  "wiki.questions": "问答",
  "wiki.questionsIntro":
    "围绕型号参数、使用经验和选型替代进行讨论，帮助更多人快速找到答案。",
  "wiki.ask": "我要提问",
  "wiki.searchQuestions": "搜索问题",
  "wiki.loadingQuestions": "正在加载问答…",
  "wiki.retry": "重试",
  "wiki.awaitingAnswer": "等待回答",
  "wiki.questionMark": "问",
  "wiki.answerMark": "答",
  "wiki.answerImage": "回答附图",
  "wiki.answerCount": "{count} 个回答",
  "wiki.answerQuestion": "回答问题",
  "wiki.writeAnswer": "写下你的回答…",
  "wiki.pendingImage": "待发布图片",
  "wiki.deleteImage": "删除图片",
  "wiki.deleteFile": "删除文件",
  "wiki.attachmentHelp":
    "支持 PNG/JPG/GIF/WebP 图片及 PDF/TXT/CSV/DOCX/XLSX/PPTX 文件；合计最多 8 个，每个不超过 10MB",
  "wiki.addImage": "添加图片",
  "wiki.addFile": "添加文件",
  "wiki.cancel": "取消",
  "wiki.publishAnswer": "发布回答",
  "wiki.noQuestions": "暂未找到相关问题",
  "wiki.firstQuestion": "发布第一个问题",
  "wiki.continueBrowsing": "继续浏览",
  "wiki.similarQuestions": "类似问题",
  "wiki.similarHint": "这些问题也许能帮你更快找到答案",
  "wiki.discussionCount": "{count} 个讨论",
  "wiki.hotQuestions": "热门问答",
  "wiki.noHotQuestions": "暂时还没有热门讨论",
  "wiki.answerInvitations": "等你来答",
  "wiki.relatedProducts": "全站相关产品提问",
  "wiki.publishQuestion": "发布问题",
  "wiki.askHint": "清楚描述问题，更容易获得有价值的回答",
  "wiki.discussing": "正在讨论",
  "wiki.questionRules": "发布问答规则",
  "wiki.ruleRelevant": "围绕当前产品的参数、使用经验和选型替代进行提问",
  "wiki.ruleNoTrade": "请勿发布交易、联系方式或与产品无关的信息",
  "wiki.questionTitle": "问题标题",
  "wiki.titleHint": "一句话说明你想了解的内容",
  "wiki.titleExample": "例如：该型号可以直接替代同系列产品吗？",
  "wiki.details": "补充说明",
  "wiki.detailsHint": "可补充使用场景、已确认参数或遇到的现象",
  "wiki.detailsPlaceholder":
    "提供更多背景信息，可以帮助大家更准确地回答你的问题…",
  "wiki.productFallback": "该产品",
  "wiki.allQuestions": "全部问答",
  "wiki.communityQuestions": "社区问答",
  "wiki.wikiUser": "百科用户",
  "wiki.communityUser": "社区用户",
  "wiki.loginFirst": "请先登录",
  "wiki.operationFailed": "操作失败，请稍后重试，草稿已保留",
  "wiki.loadFailed": "问答加载失败，请确认产品链接后重试。",
  "wiki.fileInvalid": "{name} 的格式或大小不符合要求",
  "wiki.fileLimit": "图片和文件合计最多 8 个",
  "wiki.enterFromProduct": "请从产品百科进入问答后提问",
  "wiki.questionPublished": "问题已发布",
  "wiki.answerPublished": "回答已发布",
  "wiki.heroTitle": "芯片百科，让知识触手可及",
  "wiki.searchPlaceholder": "搜索型号、品牌、分类",
  "wiki.categoryLabel": "芯片分类：",
  "wiki.productCount": "{count} 个产品",
  "wiki.collapse": "收起",
  "wiki.expand": "展开",
  "wiki.brandLabel": "品牌：",
  "wiki.brandInitials": "按品牌首字母筛选",
  "wiki.brandFilter": "品牌筛选",
  "wiki.all": "全部",
  "wiki.publishEntry": "发布词条",
  "wiki.noDescription": "暂无描述",
  "wiki.unfavorite": "取消收藏",
  "wiki.favorite": "收藏",
  "wiki.loadingMore": "正在加载…",
  "wiki.loadMoreProducts": "加载更多产品",
  "wiki.noProducts": "暂无相关产品信息",
  "wiki.publishEntryTitle": "发布百科词条",
  "wiki.publishEntryHint": "提交后进入百科审核，审核通过后展示到公开百科库。",
  "wiki.entryName": "词条名称",
  "wiki.entryNamePlaceholder": "请输入百科词条名称",
  "wiki.entryDefinition": "词条释义",
  "wiki.entryDefinitionPlaceholder":
    "请说明该百科内容是什么、用于什么场景、有哪些关键特征",
  "wiki.entryBody": "百科正文",
  "wiki.entryBodyPlaceholder": "请补充背景、用途、参数含义或选型说明",
  "wiki.publishReason": "发布说明",
  "wiki.publishReasonPlaceholder": "例如：新增型号百科、补充资料来源",
  "wiki.datasheetOptional": "规格书（选填）",
  "wiki.choosePdf": "选择 PDF 规格书",
  "wiki.pdfHelp": "仅支持 PDF，最大 50MB；不上传也可以正常发布。",
  "wiki.publishMode": "发布方式",
  "wiki.immediate": "立即发布",
  "wiki.scheduled": "计划发布",
  "wiki.scheduledAt": "计划发布时间",
  "wiki.chooseFutureTime": "选择未来的发布时间",
  "wiki.scheduleHelp":
    "提交后先进入百科审核；只有审核通过，才会在计划时间发布到公开百科。",
  "wiki.manageSchedule": "管理已保存的计划发布",
  "wiki.saveSchedule": "保存计划",
  "wiki.submitReview": "提交审核",
  "wiki.scheduleManager": "计划发布管理",
  "wiki.noScheduled": "暂无待发布的百科内容",
  "wiki.scheduledTime": "计划发布时间：",
  "wiki.changeTime": "修改时间",
  "wiki.publishNow": "立即发布",
  "wiki.cancelSchedule": "取消计划",
  "wiki.reviewProcess": "智能体审核过程",
  "wiki.checked": "已完成检查",
  "wiki.failed": "失败",
  "wiki.complete": "完成",
  "wiki.factCheck": "逐项事实核验",
  "wiki.factClaim": "事实声明",
  "wiki.datasheetPage": "规格书第 {page} 页",
  "wiki.noPage": "暂无可定位的原文页码",
  "wiki.reviseHint": "请根据{opinion}修改词条，完成后重新提交审核。",
  "wiki.reviseByOpinion": "按照意见修改",
  "wiki.withdrawHint": "如果不想继续本次发布，可以撤回投稿并保留为草稿。",
  "wiki.withdraw": "撤回投稿",
  "wiki.withdrawnHint":
    "投稿已撤回，不再进入审核队列。你可以继续编辑或删除草稿。",
  "wiki.continueEdit": "继续编辑",
  "wiki.deleteDraft": "删除草稿",
  "wiki.manualReviewOpinion": "人工复核意见（退回修改或审核不通过时填写）",
  "wiki.manualReviewPlaceholder":
    "请明确填写需要用户修改的内容和原因，提交后用户可在审核意见中查看",
  "wiki.manualReviewRequired":
    "审核通过无需填写；退回修改或审核不通过时意见不能为空",
  "wiki.approvePublish": "审核通过并发布",
  "wiki.returnForRevision": "确认退回修改",
  "wiki.rejectReview": "审核不通过",
  "wiki.reviewManagement": "审核发布管理",
  "wiki.reviewManagementHint": "管理该百科条目是否允许进入公开百科库",
  "wiki.currentStatus": "当前状态",
  "wiki.completeness": "资料完整度",
  "wiki.readyToPublish": "满足发布检查",
  "wiki.completeBeforePublish": "建议补齐后再发布",
  "wiki.publishCheck": "发布检查",
  "wiki.present": "已齐",
  "wiki.missing": "待补",
  "wiki.missingFields": "待补字段：",
  "wiki.allProducts": "全部产品",
  "wiki.otherInitial": "其他",
  "wiki.batchReview": "批量提交百科审核",
  "wiki.batchReviewHint":
    "每条内容都会独立进入智能审核；只有审核通过后，才会展示到公开百科库。",
  "wiki.uploadExtract": "上传文件自动提取百科内容",
  "wiki.batchImportHelp":
    "支持 xlsx、xls、csv、json、txt。表格表头可用：词条名称、词条释义、百科正文、发布说明、品牌、分类。",
  "wiki.parsedFile": "已解析：",
  "wiki.batchSize": "每批条数",
  "wiki.itemsUnit": "条",
  "wiki.submitInterval": "提交间隔",
  "wiki.secondsUnit": "秒",
  "wiki.batchDefaultHint":
    "默认每 5 秒提交 10 条，每条都会调用后端正式审核接口，不会直接发布。",
  "wiki.submittingEach": "正在逐条提交审核",
  "wiki.batchCancelled": "已取消分批提交",
  "wiki.submitProgress": "审核提交进度",
  "wiki.batchNext": "本批完成后，{seconds} 秒后继续提交下一批。",
  "wiki.batchRemaining": "剩余 {count} 条尚未提交，可修改后重新开始。",
  "wiki.batchFailed": "{count} 条提交失败，已保留在列表中，可稍后重试。",
  "wiki.totalItems": "共 {count} 条",
  "wiki.addOne": "添加一条",
  "wiki.entryNumber": "百科词条 {number}",
  "wiki.entryNameMissing": "未填写词条名称",
  "wiki.fillFromFile": "从文件填充本条",
  "wiki.delete": "删除",
  "wiki.brand": "品牌",
  "wiki.category": "分类",
  "wiki.extractFromFile": "可由文件自动提取",
  "wiki.addEntry": "添加一条百科",
  "wiki.cancelSubmit": "取消提交",
  "wiki.submittingReview": "正在提交审核",
  "wiki.continueSubmit": "继续提交审核",
  "wiki.startBatchSubmit": "开始分批提交审核",
  "wiki.entryKicker": "芯片百科词条",
  "wiki.copyEntryName": "复制词条名称",
  "wiki.edit": "修改",
  "wiki.favorited": "已收藏",
  "wiki.entryDefinitionPlaceholderShort": "请输入词条释义",
  "wiki.introLoading": "正在加载产品简介…",
  "wiki.noIntro": "该产品暂无简介内容",
  "wiki.contents": "目录",
  "wiki.basicInfo": "基本信息",
  "wiki.datasheetResults": "规格书 PDF 与解析结果",
  "wiki.fullscreen": "全屏浏览",
  "wiki.downloadDatasheet": "规格书下载",
  "wiki.datasheet": "规格书",
  "wiki.exitFullscreen": "退出全屏浏览",
  "wiki.noDatasheet": "该产品暂未关联规格书 PDF",
  "wiki.datasheetLabel": "规格书：",
  "wiki.noFilename": "暂无文件名",
  "wiki.parsingStatus": "解析状态：",
  "wiki.datasheetCharts": "规格书相关图表",
  "wiki.specification": "规格说明",
  "wiki.technicalFeatures": "技术特点",
  "wiki.summaryLoading": "正在检索规格书并生成说明…",
  "wiki.applications": "应用领域",
  "wiki.usageNotes": "使用注意事项",
  "wiki.backToCommunity": "返回知道首页",
  "wiki.recommendedTopics": "推荐专题",
  "wiki.topicIntroduction": "专题导读",
  "wiki.engineeringGuide": "工程实践指南",
  "wiki.backToOverview": "返回概览",
  "wiki.featuredQnA": "精选问答",
  "wiki.questionCount": "{count} 个问题",
  "wiki.topicContents": "专题内容",
  "wiki.ordinal1": "一",
  "wiki.ordinal2": "二",
  "wiki.ordinal3": "三",
  "wiki.ordinal4": "四",
  "wiki.ordinal5": "五",
  "wiki.ordinal6": "六",
  "wiki.ordinal7": "七",
  "wiki.backToCommunityShort": "返回知道",
  "wiki.userQnA": "用户问答",
  "wiki.experienceSharing": "技术交流 · 经验共享",
  "wiki.experienceIntro": "让真实经验与可靠依据，在这里相遇。",
  "wiki.revalidateLogin": "重新验证登录",
  "wiki.currentLocation": "当前位置",
  "wiki.allQuestionsShort": "全部问题",
  "wiki.questionDetails": "问题详情",
  "wiki.communityDiscussion": "社区讨论",
  "wiki.hasAcceptedAnswer": "已有采纳回答",
  "wiki.allAnswers": "全部回答",
  "wiki.experienceValued": "每一种经验，都值得被看见",
  "wiki.noAnswersYet": "还没有回答，欢迎分享你的经验。",
  "wiki.aiReference": "AI 参考",
  "wiki.basedOnEncyclopedia": "基于百科资料",
  "wiki.sharedExperience": "分享实际经验",
  "wiki.accepted": "已采纳",
  "wiki.unlike": "取消点赞",
  "wiki.helpful": "有帮助",
  "wiki.unaccept": "取消采纳",
  "wiki.acceptAnswer": "采纳回答",
  "wiki.yourAnswer": "自己的回答",
  "wiki.comments": "评论",
  "wiki.loadingComments": "正在加载评论…",
  "wiki.noComments": "还没有评论。",
  "wiki.writeComment": "写下你的评论",
  "wiki.postComment": "发布评论",
  "wiki.shareInsight": "分享你的见解",
  "wiki.replyHint": "写下实际经验，也欢迎附上规格书或测试依据。",
  "wiki.writeAnswerWithEvidence": "写下你的回答和依据",
  "wiki.addAttachment": "添加图片或文档",
  "wiki.attachmentLimit": "最多 8 个，每个不超过 10MB",
  "wiki.uploading": "上传中…",
  "wiki.remove": "移除",
  "wiki.questionCountTogether": "{count} 个问题 · 一起寻找答案",
  "wiki.searchUserQuestions": "搜索用户问题",
  "wiki.search": "搜索",
  "wiki.noQuestionsPostFirst": "暂无相关问题，欢迎发布第一个问题。",
  "wiki.backToQnA": "返回问答",
  "wiki.technicalQnADetails": "技术问答详情",
  "wiki.questionProductIntro":
    "围绕 {product} 的参数、选型和实际应用经验进行讨论，欢迎分享规格书依据或实际项目经验。",
  "wiki.moreExperienceWelcome": "个回答，更多经验等你补充",
  "wiki.letMeAnswer": "我来回答",
  "wiki.helpEngineers": "分享经验，帮助更多工程师",
  "wiki.encyclopediaCommunity": "百科知识 · 社区交流",
  "wiki.communityExperience": "来自社区的经验",
  "wiki.sortByTime": "按时间排序",
  "wiki.loadingAnswers": "正在加载回答…",
  "wiki.aiReferenceAnswer": "AI 参考回答",
  "wiki.encyclopediaContent": "百科内容",
  "wiki.experienceShared": "经验分享",
  "wiki.viewAnswerEvidence": "查看回答依据",
  "wiki.viewProductEntry": "查看产品百科",
  "wiki.hideComments": "收起评论",
  "wiki.deleting": "删除中…",
  "wiki.deleteAnswer": "删除回答",
  "wiki.continueDiscussion": "围绕这条回答继续交流",
  "wiki.noCommentsInvite": "还没有评论，来分享你的看法或补充问题吧。",
  "wiki.commentOnAnswer": "评论 {author} 的回答",
  "wiki.commentPlaceholder": "针对这条回答，说说你的看法…",
  "wiki.commentSavedNotice": "评论将保存到社区",
  "wiki.answerDetailPlaceholder": "分享你的规格书依据、测试结果或实际使用经验…",
  "wiki.deleteNamedImage": "删除图片 {name}",
  "wiki.deleteNamedFile": "删除文件 {name}",
  "wiki.attachmentSavedHelp":
    "支持 PNG/JPG/GIF/WebP 图片及 PDF/TXT/CSV/DOCX/XLSX/PPTX 文件，合计最多 8 个，每个不超过 10MB。附件随回答保存。",
  "wiki.relatedSearches": "相关搜索",
  "wiki.othersSearch": "大家还在搜",
  "wiki.generatingRelated": "正在生成相关搜索…",
  "wiki.regenerate": "重新生成",
  "wiki.makeExperienceVisible": "让经验被更多人看见",
  "wiki.yourExperienceAnswer": "你的实践，可能正是他人的答案。",
  "wiki.shareEvidence": "分享规格书依据、测试结果或项目中积累的使用经验。",
  "wiki.joinAnswering": "参与回答",
  "wiki.noPendingAnswers": "暂时没有等待用户回答的问题",
  "wiki.communityMark": "知",
  "wiki.chipQnA": "芯片知道",
  "wiki.technicalCommunity": "技术问答社区",
  "wiki.communitySearchPlaceholder": "搜索型号、封装、参数或技术问题",
  "wiki.searchAnswers": "搜索答案",
  "wiki.xsouQnA": "XSOU 知道",
  "wiki.reliableAnswers": "让每个技术问题，都有可靠的回答",
  "wiki.communityIntro":
    "围绕芯片型号、规格参数、封装兼容和实际应用经验展开讨论。",
  "wiki.technicalQuestions": "技术问题",
  "wiki.professionalAnswers": "专业回答",
  "wiki.popularChipTypes": "常搜芯片类型",
  "wiki.semiconductorBasics": "半导体基础知识",
  "wiki.hotDiscussions": "热门讨论",
  "wiki.everyoneAsks": "大家都在问",
  "wiki.viewAll": "查看全部",
  "wiki.searchProductForAi": "搜索具体产品型号，获取基于百科内容生成的 AI 问答",
  "wiki.chipImage": "{product} 芯片",
  "wiki.communityContribution": "社区贡献",
  "wiki.influenceRanking": "影响力排行",
  "wiki.loadingCommunityRecords": "正在读取社区记录",
  "wiki.aiRolesDisclaimer":
    "暂无真人问答，以下展示 AI 角色，不代表真人贡献排名",
  "wiki.weeklyRankingNote": "按本周发言量与回答获赞数展示",
  "wiki.weeklyActive": "本周活跃答主",
  "wiki.roleDisplay": "角色展示",
  "wiki.weeklyPosts": "本周发言",
  "wiki.qualityContributors": "优质回答贡献者",
  "wiki.contributionSummary":
    "{answers} 个回答 · {comments} 个评论 · {likes} 次有帮助",
  "wiki.likesReceived": "获赞数",
  "wiki.awaitingProfessionalAnswer": "这些问题正在等待专业回答",
  "wiki.reload": "重新加载",
  "wiki.searchingQnA": "正在搜索相关问答…",
  "wiki.searchIncomplete": "搜索暂时未完成",
  "wiki.searchResultCount": "共搜索到 {count} 条结果",
  "wiki.findingQnA": "正在查找相关问答",
  "wiki.matchingKnowledge": "正在匹配已发布的产品知识，请稍候…",
  "wiki.loadQuestionsFailed": "问答暂时加载失败",
  "wiki.retrySearchHint": "请稍后重试，我们会重新获取搜索结果。",
  "wiki.noRelatedQnA": "暂未找到相关问答",
  "wiki.noMatchFor": "未找到与“{keyword}”匹配的已发布问答",
  "wiki.noPublishedQnA": "目前还没有可展示的已发布问答",
  "wiki.tryFullModel":
    "试试完整产品型号，或减少关键词；也可以检查型号中的字母、数字是否正确。",
  "wiki.hotSearches": "热门搜索",
  "wiki.noRealSearches": "暂无真实搜索记录",
  "wiki.communityRuleRelevant":
    "围绕芯片型号、规格参数、使用经验和选型替代进行提问。",
  "wiki.communityRuleNoTrade": "请勿发布交易、联系方式或与芯片无关的信息。",
  "wiki.communityTitleExample": "例如：IS62WV51216 的封装兼容性如何确认？",
  "wiki.communityDetailsPlaceholder":
    "可补充具体型号、使用场景、已确认参数或遇到的现象…",
  "wiki.postQuestionHint": "发布后可在问题详情中查看回答，与其他用户交流。",
  "wiki.fitPage": "适配页面",
  "wiki.rotate": "旋转",
  "wiki.annotate": "标注",
  "wiki.undo": "撤销",
  "wiki.redo": "重做",
  "wiki.download": "下载",
  "wiki.print": "打印",
  "wiki.more": "更多",
  "wiki.datasheetThumbnailPage": "规格书缩略图第{page}页",
  "wiki.productDatasheetPage": "{model} 规格书第{page}页",
  "wiki.packageInfo": "封装信息",
  "wiki.packageImage": "封装图",
  "wiki.packageType": "封装类型",
  "wiki.pinCount": "引脚数",
  "wiki.packageSize": "封装尺寸",
  "wiki.operatingTemperature": "工作温度",
  "wiki.relatedTerms": "相关术语",
  "wiki.references": "参考资料",
  "wiki.sameSeriesDatasheets": "同系列规格书推荐",
  "wiki.sameSeriesHint": "优先匹配产品系列和型号族，数据直接来自远端寻知知识库",
  "wiki.modelCount": "{count} 个型号",
  "wiki.loadingSameSeries": "正在加载同系列规格书",
  "wiki.sameSeriesFailed": "同系列规格书加载失败",
  "wiki.indexedAt": "收录日期",
  "wiki.noSameSeries": "暂未找到同系列规格书",
  "wiki.noSameSeriesHint":
    "远端知识库中暂无明确的同系列型号，可以让 AI 助手继续检索相近产品。",
  "wiki.askAi": "询问 AI 助手",
  "wiki.relatedKnowledgeProducts": "相关知识库产品",
  "wiki.relatedProductsHint":
    "按制造商、产品分类和型号相似度推荐，不混入库存或价格演示数据",
  "wiki.loadingRelatedProducts": "正在加载相关知识库产品",
  "wiki.relatedProductsFailed": "相关产品加载失败",
  "wiki.noRelatedKnowledgeProducts": "暂未找到相关知识库产品",
  "wiki.noRelatedKnowledgeHint":
    "可以让 AI 助手根据当前型号的参数和用途进行全库推荐。",
  "wiki.aiRecommend": "让 AI 推荐",
  "wiki.siteLinks": "站内相关入口",
  "wiki.siteLinksHint": "当前词条可继续查看站内关联资料",
  "wiki.imageMaterials": "图片资料",
  "wiki.uploadImage": "上传图片",
  "wiki.deleteCurrent": "删除当前",
  "wiki.previousImage": "上一张",
  "wiki.nextImage": "下一张",
  "wiki.noImagesUpload": "暂无图片资料，可上传补充",
  "wiki.noImages": "暂无图片资料",
  "wiki.videoMaterials": "视频资料",
  "wiki.uploadVideo": "上传视频",
  "wiki.deleteVideo": "删除视频",
  "wiki.videoNumber": "视频 {number}",
  "wiki.noVideosUpload": "暂无视频资料，可上传补充",
  "wiki.videosViaEdit": "视频资料可通过修改词条补充",
  "wiki.entryStats": "百科信息区",
  "wiki.viewsCount": "浏览次数：{count} 次",
  "wiki.editsCount": "编辑次数：{count} 次",
  "wiki.history": "历史版本",
  "wiki.latestAt": "最近时间：",
  "wiki.latestEditor": "最近会员：",
  "wiki.topContributors": "突出贡献榜",
  "wiki.contributorEdits": "{count} 次编辑",
  "wiki.relatedInfo": "相关信息",
  "wiki.relatedTags": "相关标签",
  "wiki.detail.alreadyPublished":
    "该词条已发布，无需重复审核发布；如需补充资料，可直接在词条内容区点击“修改”。",
  "wiki.detail.aiCorrections": "AI 修正建议",
  "wiki.detail.aiCorrectionsHint":
    "以下建议均需有资料证据支持。确认后系统会生成修正版并重新审核，不会直接发布。",
  "wiki.detail.awaitingConfirmation": "待你确认",
  "wiki.detail.before": "修改前",
  "wiki.detail.suggested": "建议修改为",
  "wiki.detail.reason": "理由：{reason}",
  "wiki.detail.evidence": "证据：{evidence}",
  "wiki.detail.evidenceBased": "根据审核证据修正",
  "wiki.detail.viewCorrected": "查看 AI 修正后的完整内容",
  "wiki.detail.acceptCorrections": "接受修正并重新审核",
  "wiki.detail.manualReview": "不确认，转人工复核",
  "wiki.detail.saveAndReview": "保存并提交审核",
  "wiki.detail.saveDraft": "保存草稿",
  "wiki.detail.save": "保存",
  "wiki.detail.resubmitReview": "保存并重新提交审核",
  "wiki.detail.saveAndPublish": "保存并发布",
  "wiki.detail.loginToEdit": "请先登录，登录后才能修改百科词条",
  "wiki.detail.draftUnavailable": "暂未生成可编辑的百科草稿，请稍后重试",
  "wiki.detail.draftLoadFailed": "加载百科草稿失败，请稍后重试",
  "wiki.detail.loginToPublish": "请先登录，登录后才能修改或发布百科词条",
  "wiki.detail.requiredFields": "请填写词条名称、词条释义和百科正文",
  "wiki.detail.revisionSubmitted":
    "修改已提交审核，审核通过并发布后将计入编辑次数",
  "wiki.detail.submitFailed": "修改提交失败",
  "wiki.detail.largeFile": "保存失败，上传文件可能过大，请删除或压缩后再保存",
  "wiki.detail.saveFailed": "保存修改失败",
  "wiki.detail.revisionSaved": "修改已提交，已记录为新的词条版本",
  "wiki.detail.draftNotFound": "未找到可保存的百科草稿",
  "wiki.detail.draftSaveFailed": "保存百科草稿失败",
  "wiki.detail.correctionsConfirmed": "AI 修正已确认，修正版已重新提交审核",
  "wiki.detail.correctionsFailed": "确认 AI 修正失败",
  "wiki.detail.sentToHuman": "已转入人工复核，请在“我的发布”查看进度",
  "wiki.detail.humanReviewFailed": "转人工复核失败",
  "wiki.detail.loginToRelease": "请先登录，登录后才能发布百科词条",
  "wiki.detail.releaseFailed": "发布百科内容失败",
  "wiki.detail.draftSaved": "百科草稿已保存到数据库",
  "wiki.detail.needsRevision": "审核认为内容需要修改，请完善后重新提交",
  "wiki.detail.highRisk": "内容存在高风险或不确定项，已转人工复核",
  "wiki.detail.reviewSubmitted": "百科内容已提交智能审核",
  "wiki.detail.scheduled": "智能审核通过，已进入计划发布",
  "wiki.detail.rewarded": "百科内容审核通过并发布，+{points} 积分",
  "wiki.detail.rewardLimit":
    "百科内容审核通过并发布；今日奖励已达 {limit} 积分上限",
  "wiki.detail.published": "百科内容已发布",
  "wiki.detail.reviewStatus": "内容已提交审核，审核结果可在“我的”中进行查看",
  "wiki.detail.reviewRewarded":
    "百科内容审核通过，+{points} 积分，点击查看明细",
  "wiki.detail.reviewRewardLimit":
    "百科内容审核通过；今日奖励已达 {limit} 积分上限",
  "wiki.detail.assistantTitle": "百科 AI 助手",
  "wiki.detail.assistantSubtitle": "自动检索百科与规格书",
  "wiki.detail.collapseAssistant": "收回",
  "wiki.detail.viewConversation": "查看对话",
  "wiki.detail.me": "我",
  "wiki.detail.sourceCatalog": "来自产品库中的实际型号",
  "wiki.detail.sourceClarify": "需要补充提问信息",
  "wiki.detail.sourceModel": "基于模型通用知识，非规格书原文依据",
  "wiki.detail.sourceAll": "本次已自动检索全部知识库规格书",
  "wiki.detail.sourceCurrent": "本次已自动检索当前词条规格书",
  "wiki.detail.datasheet": "规格书",
  "wiki.detail.page": "第 {page} 页",
  "wiki.detail.parameterRecord": "参数记录",
  "wiki.detail.tryAsking": "试试这样问",
  "wiki.detail.voltageQuestion": "这个产品的工作电压是多少？",
  "wiki.detail.packageQuestion": "这个产品采用什么封装形式？",
  "wiki.detail.compareQuestion": "对比这个产品和同类型号的工作电压与封装。",
  "wiki.detail.searchQuestion": "知识库中有哪些支持 3V 供电的产品？",
  "wiki.detail.voltage": "工作电压",
  "wiki.detail.package": "封装形式",
  "wiki.detail.compare": "同类对比",
  "wiki.detail.searchAll": "全库查找",
  "wiki.detail.assistantLongWait":
    "本次处理时间较长，请稍候。你也可以随时暂停。",
  "wiki.detail.assistantWorking": "会结合对话内容，并按问题需要检索资料。",
  "wiki.detail.seconds": "{count} 秒",
  "wiki.detail.questionPlaceholder": "输入百科问题、型号、品牌或对比需求…",
  "wiki.detail.pauseAnswer": "暂停本次回答",
  "wiki.detail.pause": "暂停",
  "wiki.detail.send": "发送",
  "wiki.detail.sourceHint": "自动选择检索范围，回答附原文依据",
  "wiki.detail.shortcut": "Ctrl + Enter 发送",
  "wiki.detail.schedulePrompt": "请输入发布时间（例如 2026-08-03 18:30:00）",
  "wiki.detail.scheduleTitle": "计划发布百科正文",
  "wiki.detail.scheduleFormat":
    "请输入 YYYY-MM-DD HH:mm 或 YYYY-MM-DD HH:mm:ss",
  "wiki.detail.scheduleFuture": "发布时间必须晚于当前时间",
  "wiki.detail.scheduleSaved": "已保存计划，到设定时间将自动发布正文",
  "wiki.detail.scheduleFailed": "计划发布百科内容失败",
});

export const messages = Object.freeze({ ...personal, ...display, ...pages });
